(function () {
    const $ = (selector) => document.querySelector(selector);
    const $$ = (selector) => Array.from(document.querySelectorAll(selector));

    const CATCOLOR = {
        AI: "var(--signal)",
        Policy: "var(--policy)",
        Funding: "var(--funding)",
        Hospitals: "var(--hosp)",
        Startups: "var(--startup)",
        Global: "#5a6b6a",
    };

    const ARTICLES = [
        {
            id: "samsung",
            cat: "Hospitals",
            label: "Featured",
            title: "90 Cr ABHA IDs, 100 Cr Linked Records: Why India's EHR Market Matters Now",
            image: "https://d33xmv9j3wn8v0.cloudfront.net/uploads/2026/06/emr-feature.png",
            by: "DHN Bureau",
            read: "3 min",
            what: "India has crossed more than 90 crore ABHA IDs and over 100 crore linked health records, pushing the EHR market into a new growth phase.",
            why: "The milestone signals that India is moving from hospital-level digitisation toward connected, consent-led health data infrastructure.",
            take: "The next test is not only record linkage. Hospitals, clinicians and healthtech companies now need workflows that turn those records into useful, governed and clinically actionable data.",
            watch: "How quickly ABDM-ready platforms, cloud EHRs and AI-enabled documentation tools move from pilots into everyday hospital workflows.",
        },
        {
            id: "enzo",
            cat: "Startups",
            label: "Exclusive",
            title: "Enzo Health Launches an AI-Native, Agentic EHR Built for Home-Health Agencies",
            image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80",
            by: "Aditi Verma",
            read: "4 min",
            what: "Enzo Health has released what it calls an agentic EHR — a records system where AI agents draft notes, chase documentation gaps and pre-fill billing rather than passively storing data.",
            why: "Home health is the most documentation-heavy, least digitised corner of care. An agentic layer attacks the exact labour cost that keeps margins thin.",
            take: '"AI-native EHR" will be the most abused phrase of 2026. The test is whether agents reduce clinician keystrokes by a measurable margin, not whether a chatbot sits in a sidebar. Enzo is worth watching precisely because home health gives a clean before/after.',
            watch: "Pilot retention after month three — agentic tools that delight in demos often get switched off when they hallucinate a billing code.",
        },
        {
            id: "medidata",
            cat: "AI",
            label: "Global",
            title: "Owkin, Sanofi Expand AI Collaboration to Develop Drug Discovery Agents",
            image: "https://d33xmv9j3wn8v0.cloudfront.net/uploads/2026/06/lg/owkin-sanofi-expand-ai-feature-1.webp",
            by: "DHN Bureau",
            read: "3 min",
            what: "Owkin and Sanofi have expanded their AI collaboration to build drug discovery agents for research workflows.",
            why: "Agent-based AI is moving deeper into pharma R&D, where speed, evidence quality and repeatable discovery workflows matter.",
            take: "The practical signal is that AI in life sciences is shifting from model demos to workflow agents that can support research teams across discovery steps.",
            watch: "Whether similar AI-agent partnerships begin shaping clinical research, CRO and pharma innovation strategies in India.",
        },
        {
            id: "boston",
            cat: "AI",
            label: "",
            title: "Novant Health Launches AI-powered Virtual Health Assistant Aubrey",
            image: "https://d33xmv9j3wn8v0.cloudfront.net/uploads/2026/06/lg/novant-health-introduces-feature-1.webp",
            by: "DHN Bureau",
            read: "3 min",
            what: "Novant Health has launched Aubrey, an AI-powered virtual health assistant designed to support patient navigation and access.",
            why: "Health systems are turning the digital front door into an AI-assisted experience, reducing friction before patients reach a clinic or call centre.",
            take: "The competitive edge will be whether virtual assistants can resolve real patient needs safely, not only answer common questions.",
            watch: "How hospitals measure adoption, escalation quality and patient satisfaction as AI assistants become part of care access.",
        },
        {
            id: "yatharth",
            cat: "Hospitals",
            label: "",
            title: "Yatharth Hospitals Appoints Dr. Prahlad Agrawal As COO",
            image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=1200&q=80",
            by: "DHN Bureau",
            read: "3 min",
            what: "Yatharth Hospitals has appointed Dr. Prahlad Agrawal as Chief Operating Officer.",
            why: "Leadership movement inside hospital networks is a signal of where operational transformation and expansion priorities are heading.",
            take: "Hospital operating roles are becoming more strategic as chains balance growth, digital operations, clinician experience and patient throughput.",
            watch: "How the appointment shapes Yatharth's hospital operations, quality systems and digital transformation roadmap.",
        },
        {
            id: "pm-modi",
            cat: "Hospitals",
            label: "",
            title: "PM Modi Inaugurates Namo Hospital in Daman, Highlights Digital Health Mission",
            image: "https://images.unsplash.com/photo-1584515933487-779824d29309?w=1200&q=80",
            by: "DHN Bureau",
            read: "3 min",
            what: "Prime Minister Narendra Modi inaugurated Namo Hospital in Daman and highlighted the role of India's digital health mission.",
            why: "Public health infrastructure announcements are increasingly tied to digital health, access and connected-care priorities.",
            take: "The digital-health angle is no longer a side note in hospital launches. It is becoming part of how governments describe healthcare capacity itself.",
            watch: "Whether new public facilities embed ABDM, digital registration and connected records from the start.",
        },
        {
            id: "andhra",
            cat: "AI",
            label: "",
            title: "Andhra Health Minister Announces Plan to Deploy AI-based App for Neonatal Care",
            image: "https://images.unsplash.com/photo-1576671414121-aa0c81c869e1?w=1200&q=80",
            by: "DHN Bureau",
            read: "3 min",
            what: "Andhra Pradesh's health minister has announced plans to deploy an AI-based app for neonatal care.",
            why: "Neonatal care is a high-impact use case where early risk detection, triage and follow-up can materially affect outcomes.",
            take: "AI in public health will be judged on deployment discipline: clinical validation, frontline usability and clear escalation pathways.",
            watch: "How the state integrates the app with existing maternal and child health workflows.",
        },
        {
            id: "charaka",
            cat: "Hospitals",
            label: "",
            title: "CHARAKA Signs MoU with BFI to Strengthen Karnataka’s Health Innovation Ecosystem",
            image: "https://images.unsplash.com/photo-1576671081837-49000212a370?w=1200&q=80",
            by: "Aditi Verma",
            read: "3 min",
            what: "Karnataka’s CHARAKA initiative has inked an MoU with BFI to deepen the state’s healthcare innovation pipeline.",
            why: "State-level innovation infrastructure is where ABDM ambitions either become real or stall. Karnataka is positioning to lead.",
            take: "The states that win digital health will be those that pair public rails with private execution. MoUs are cheap; the signal will be in the first three funded pilots.",
            watch: "Which startups get the first procurement contracts under the partnership.",
        },
        {
            id: "faridabad",
            cat: "Startups",
            label: "",
            title: "Faridabad Startup Raises $100K to Scale AI-Powered Health Kiosks in Underserved Areas",
            image: "https://d33xmv9j3wn8v0.cloudfront.net/uploads/2026/03/compress/seqrite-report-feature.webp",
            by: "Rohan Desai",
            read: "3 min",
            what: "A Faridabad-based startup has raised $100K in early funding to expand AI-driven diagnostic kiosks into underserved regions.",
            why: "Last-mile diagnostics is India’s hardest digital-health problem. Kiosks are a credible wedge if unit economics hold.",
            take: "Small cheque, big thesis. The question every kiosk startup must answer: what happens to the abnormal result? A screen without a referral pathway is a vanity metric.",
            watch: "Whether the kiosks integrate with ABDM health IDs and local referral networks.",
        },
        {
            id: "narayana",
            cat: "Hospitals",
            label: "Analysis",
            title: "Govt Medical College in Thiruvananthapuram Completes Its First Robotic Joint Surgeries",
            image: "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=1200&q=80",
            by: "Sanjay Mehta",
            read: "4 min",
            what: "A government medical college hospital in Kerala has performed its first robotic-assisted joint replacement surgeries.",
            why: "Robotics reaching public-sector tertiary care — not just corporate chains — is a genuine equity milestone.",
            take: "The headline is access; the substance is throughput. Robotic systems justify their cost only at volume. Public hospitals must solve scheduling and training, or expensive arms sit idle.",
            watch: "Utilisation rates and whether the state funds a second system.",
        },
        {
            id: "marksans",
            cat: "Global",
            label: "",
            title: "Marksans Pharma Expands in Europe with Acquisition of Netherlands-Based QliniQ",
            image: "https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=1200&q=80",
            by: "Meera Krishnan",
            read: "2 min",
            what: "Marksans Pharma has acquired Netherlands-based QliniQ B.V. to widen its European footprint.",
            why: "Indian pharma’s European M&A continues — distribution and regulatory access remain the prize.",
            take: "Bolt-on EU acquisitions are how Indian generics buy time and shelf space. The digital-health angle: watch whether acquired platforms bring data assets, not just licences.",
            watch: "Integration pace and any digital-therapeutics capability in the QliniQ portfolio.",
        },
    ];

    const FUNDING = [
        { co: "Cellogen Therapeutics", round: "Growth", amt: "₹200 Mn", cat: "Biotech", inv: "Kotak Alts" },
        { co: "Aumet", round: "Series A", amt: "$12 Mn", cat: "Marketplace", inv: "Emkan Capital" },
        { co: "Mitsu", round: "Bridge", amt: "Undisclosed", cat: "Mental Health", inv: "Existing backers" },
        { co: "Faridabad Kiosks Co.", round: "Pre-Seed", amt: "$100 K", cat: "Diagnostics", inv: "Angel syndicate" },
        { co: "Luna Wearables", round: "Seed", amt: "$3.2 Mn", cat: "Wearables", inv: "India Quotient" },
        { co: "Credent Connect", round: "Series A", amt: "$8 Mn", cat: "Logistics", inv: "Elevation Capital" },
        { co: "Ezovion", round: "Series A", amt: "$6.5 Mn", cat: "HIS / EHR", inv: "Stakeboat Capital" },
        { co: "NeuroScan AI", round: "Seed", amt: "$2.1 Mn", cat: "AI Imaging", inv: "pi Ventures" },
    ];
    const FCATS = ["All", "AI Imaging", "Diagnostics", "HIS / EHR", "Wearables", "Biotech", "Mental Health"];
    const FCOLOR = {
        Biotech: "#c2761a",
        Marketplace: "#3a5a7a",
        "Mental Health": "#9d5ac2",
        Diagnostics: "#2e8b57",
        Wearables: "#2f5d8a",
        Logistics: "#5a6b6a",
        "HIS / EHR": "#0f9d7e",
        "AI Imaging": "#1fd4a3",
    };
    const POLICY = [
        { s: "live", cls: "s-live", t: "DPDP Act 2023 — Healthcare Rules", d: "Draft rules notified; consent-manager framework now applies to hospitals and HealthTech handling patient data.", date: "Active · enforcement window opening" },
        { s: "live", cls: "s-live", t: "ABDM — Scan & Share at Scale", d: "QR-based OPD registration now live across 1,000+ facilities, eliminating queue-time for millions.", date: "Active · expanding" },
        { s: "soon", cls: "s-soon", t: "AI in Medical Devices — CDSCO", d: "Risk-classification framework for AI/ML-based devices expected to move to consultation.", date: "Expected Q3 2026" },
        { s: "soon", cls: "s-soon", t: "Unified Health Interface (UHI)", d: "Open protocol for discovery & booking of health services entering wider pilot.", date: "Pilot · Q3 2026" },
        { s: "watch", cls: "s-watch", t: "Telemedicine Practice Guidelines 2.0", d: "Revision under review to cover asynchronous and AI-assisted consults.", date: "Watch · under review" },
        { s: "watch", cls: "s-watch", t: "Health Data Localisation", d: "Sectoral debate on whether sensitive health data must reside on-shore.", date: "Watch · contested" },
    ];
    const INDEX = [
        { st: "Kerala", v: 88 },
        { st: "Tamil Nadu", v: 84 },
        { st: "Karnataka", v: 81 },
        { st: "Maharashtra", v: 77 },
        { st: "Andhra Pradesh", v: 72 },
        { st: "Gujarat", v: 69 },
        { st: "Rajasthan", v: 58 },
        { st: "Bihar", v: 44 },
    ];
    const HUBS = [
        { ic: "◈", t: "AI in Healthcare", n: "412 stories" },
        { ic: "⬡", t: "ABDM & DPI", n: "186 stories" },
        { ic: "⛨", t: "DPDP & Data Governance", n: "97 stories" },
        { ic: "⌗", t: "Hospital Transformation", n: "304 stories" },
        { ic: "⚑", t: "HealthTech Startups", n: "528 stories" },
        { ic: "⊞", t: "EHR / HIS India", n: "143 stories" },
        { ic: "❍", t: "Telemedicine & Virtual Care", n: "201 stories" },
        { ic: "⊕", t: "Cybersecurity", n: "88 stories" },
        { ic: "◑", t: "Diagnostics & Imaging AI", n: "176 stories" },
        { ic: "❖", t: "Payers & Insurance", n: "112 stories" },
    ];
    const ECO = [
        { k: "Flagship Summit · June 18", t: "DHN Forum", p: "Government leaders, hospital CXOs, founders and investors — one stage, one agenda.", g: "linear-gradient(135deg,#0d3b34,#0c1620)", logo: "/assets/front-v2/eco-system-images/dhn-forum.png" },
        { k: "National Competition", t: "HealthTech Innovation Challenge", p: "India’s rising digital-health startups, pitched to the people who can deploy them.", g: "linear-gradient(135deg,#1a1408,#3a2a0a)", logo: "/assets/front-v2/eco-system-images/dhn-innovation-challenge-black-bg-2025.png" },
        { k: "12 cities · ongoing", t: "DHN City Meetups", p: "Ground-level insights, founder to operator, building the national narrative city by city.", g: "linear-gradient(135deg,#16323f,#0c1620)", logo: "/assets/front-v2/eco-system-images/dhn-city-meetup-logo.png" },
        { k: "Quarterly", t: "DHN Town Hall", p: "Decision-makers align on what’s next for how care is delivered and scaled.", g: "linear-gradient(135deg,#0f3a2e,#16242f)", logo: "/assets/town-hall/images/town-hall-logo.png" },
        { k: "Invitation only", t: "Leadership Council", p: "Healthcare’s most influential minds, shaping DHN’s editorial and research agenda.", g: "linear-gradient(135deg,#2a1633,#0c1620)", logo: "/assets/dhn-council/images/dhn-council-logo.png" },
        { k: "100+ episodes", t: "CxO Podcast", p: "Behind the headlines with the CIOs, CDOs and founders building what’s next.", g: "linear-gradient(135deg,#0d2b3b,#0c1620)", logo: "/assets/front-v2/eco-system-images/dhn-newsletter-podcasts.png" },
    ];
    const REPORTS = [
        { lab: "Flagship · Annual", t: "India Digital Health Outlook 2026", meta: "112 pp · April 2026", image: "/uploads/2024/06/health-monitoring-app-scaled.jpg", g: "linear-gradient(135deg,#0d3b34,#0c1620)" },
        { lab: "Market Map", t: "AI in Radiology: The India Landscape", meta: "38 vendors mapped", image: "/uploads/2024/02/student-medical-practitioner-analysing-human-body-digital-scan-holding-radiography-sitting-hospital-radiologist-medicine-uniform-looking-x-ray-examination-bone-practitioner-diagnosis.jpg", g: "linear-gradient(135deg,#1a1408,#3a2a0a)" },
        { lab: "Benchmark", t: "Hospital Digital Maturity Index", meta: "28 states scored", image: "/uploads/2024/02/nobody-hospital-facility-ward-with-modern-equipment-bed-healthcare-monitor-computer-facility-wheelchair-technology-used-healing-disease-injuy-illness-sickness-surgery.jpg", g: "linear-gradient(135deg,#16323f,#0c1620)" },
        { lab: "Survey", t: "What 200 Hospital CIOs Are Buying Next", meta: "Q2 2026 pulse", image: "/uploads/2024/02/business-team-working-new-business-plan-with-modern-digital-computer-1423-57-1.jpg", g: "linear-gradient(135deg,#2a1633,#0c1620)" },
    ];
    const NEWSLETTERS = [
        { t: "Daily Pulse", f: "Every morning", d: "The one briefing India’s health leaders open before their inbox.", flag: true },
        { t: "AI Health Weekly", f: "Thursdays", d: "AI, data, automation and GenAI in clinical and operational care." },
        { t: "Policy Radar", f: "Mondays", d: "ABDM, DPDP and regulation — decoded for hospitals and startups." },
        { t: "Startup Signal", f: "Fridays", d: "Funding, pilots and the founders to watch this week." },
        { t: "Hospital Tech Brief", f: "Bi-weekly", d: "The CIO/CDO priority list — what’s being deployed and why." },
    ];
    const STATS = [
        ["52", "K+", "Engaged professionals"],
        ["38", "K+", "Newsletter subscribers"],
        ["120", "+", "Expert podcasts"],
        ["12", "", "Cities convened"],
    ];

    const toast = (message) => {
        const toastEl = $("#toast");
        if (!toastEl) return;
        toastEl.textContent = message;
        toastEl.classList.add("is-showing");
        window.clearTimeout(window.toastTimer);
        window.toastTimer = window.setTimeout(() => toastEl.classList.remove("is-showing"), 2600);
    };

    const setDate = () => {
        const datestamp = $("#datestamp");
        if (!datestamp) return;
        datestamp.textContent =
            new Date().toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).toUpperCase() +
            " · NEW DELHI";
    };

    const renderTicker = () => {
        const ticker = $("#ticker");
        if (!ticker) return;
        ticker.innerHTML = FUNDING.concat(FUNDING)
            .map((f, index) => {
                const up = index % 3 !== 1;
                return `<span class="tk"><b>${f.co}</b> ${f.amt} <span class="${up ? "up" : "down"}">${up ? "▲" : "▼"} ${f.round}</span></span>`;
            })
            .join("");
    };

    const showOverlay = () => {
        $("#overlay")?.classList.add("show");
        document.body.style.overflow = "hidden";
    };
    const closeOverlay = () => {
        $("#overlay")?.classList.remove("show");
        document.body.style.overflow = "";
    };

    const openArticle = (article) => {
        const modalHost = $("#modalHost");
        if (!modalHost) return;
        const col = CATCOLOR[article.cat];
        modalHost.innerHTML = `<div class="modal">
            <div class="top" style="background:linear-gradient(135deg,${col},#0c1620)">
                <button class="close" type="button" data-close-overlay>×</button>
                <span class="cat">${article.cat}${article.label ? " · " + article.label : ""}</span>
                <h2>${article.title}</h2>
            </div>
            <div class="modal-body">
                <div class="by"><span>By ${article.by}</span><span>·</span><span>${article.read}</span><span>·</span><span>Updated today, New Delhi</span></div>
                <div class="msec"><div class="lab">What happened</div><p>${article.what}</p></div>
                <div class="msec"><div class="lab">Why it matters</div><p>${article.why}</p></div>
                <div class="msec mtake"><div class="lab">◆ The DHN Take</div><p>${article.take}</p></div>
                <div class="msec"><div class="lab">What to watch</div><div class="mwatch">${article.watch}</div></div>
            </div>
        </div>`;
        showOverlay();
    };

    const openPaywall = () => {
        const modalHost = $("#modalHost");
        if (!modalHost) return;
        modalHost.innerHTML = `<div class="modal paywall">
            <div class="pw-top">
                <button class="close" type="button" data-close-overlay>×</button>
                <div class="lock">🔒</div><div class="badge">DHN<span>+</span></div>
            </div>
            <div class="pw-body">
                <h3>Unlock the intelligence behind the headlines</h3>
                <ul>
                    <li>Funding trackers, policy radar &amp; market maps</li>
                    <li>Deep dives that never hit the public feed</li>
                    <li>Private CxO briefings &amp; roundtables</li>
                    <li>Every DHN report &amp; survey, first</li>
                </ul>
                <button class="pw-btn" type="button" id="claimTrialBtn">Claim 14 days free →</button>
            </div>
        </div>`;
        showOverlay();
        $("#claimTrialBtn")?.addEventListener("click", () => {
            closeOverlay();
            toast("✓ 14-day free trial — welcome to DHN+");
        });
    };

    const bindArticles = () => {
        $$("[data-article]").forEach((el) => {
            el.onclick = () => {
                const id = el.dataset.article;
                if (id === "event") {
                    toast("DHN Forum Delhi · registration opening");
                    return;
                }
                const map = { lead: "samsung", dpdp: "medidata", kotak: "boston" };
                openArticle(ARTICLES.find((article) => article.id === (map[id] || id)) || ARTICLES[0]);
            };
        });
        $$("[data-locked]").forEach((el) => {
            el.onclick = openPaywall;
        });
    };

    const renderFeed = (cat) => {
        const feedGrid = $("#feedGrid");
        if (!feedGrid) return;
        const items = ARTICLES.filter((article) => cat === "All" || article.cat === cat);
        feedGrid.innerHTML = items
            .map((article, index) => {
                const col = CATCOLOR[article.cat];
                const take = article.take.length > 120 ? article.take.slice(0, 118) + "…" : article.take;
                const storyImage = article.image
                    ? `<img class="story-image" src="${article.image}" alt="${article.title}" loading="lazy" onerror="this.remove()">`
                    : "";
                return `<article class="card" data-article="${article.id}">
                    <div class="ph" style="background:linear-gradient(135deg,${col},#0c1620)">${storyImage}
                        <span class="cat">${article.cat}</span><span class="num">${String(index + 1).padStart(2, "0")}</span></div>
                    <div class="cbody">
                        <h3>${article.title}</h3>
                        <div class="take"><b>DHN Take</b><br>${take}</div>
                        <div class="by"><span>${article.by}</span><span>${article.read}</span></div>
                    </div>
                </article>`;
            })
            .join("");
        bindArticles();
    };

    const renderFilters = () => {
        const filters = $("#filters");
        if (!filters) return;
        const categories = ["All", "AI", "Policy", "Funding", "Hospitals", "Startups", "Global"];
        filters.innerHTML = categories.map((cat, index) => `<button class="chip ${index === 0 ? "active" : ""}" data-cat="${cat}">${cat}</button>`).join("");
        filters.addEventListener("click", (event) => {
            const button = event.target.closest(".chip");
            if (!button) return;
            $$("#filters .chip").forEach((chip) => chip.classList.remove("active"));
            button.classList.add("active");
            renderFeed(button.dataset.cat);
        });
    };

    let fundingCategory = "All";
    const renderFund = () => {
        const fundFilters = $("#fundFilters");
        const fundBody = $("#fundBody");
        if (!fundFilters || !fundBody) return;
        fundFilters.innerHTML =
            FCATS.map((cat) => `<button class="fchip ${cat === fundingCategory ? "active" : ""}" data-fc="${cat}">${cat}</button>`).join("") +
            '<span class="fund-stat" id="fstat"></span>';
        const rows = FUNDING.filter((fund) => fundingCategory === "All" || fund.cat === fundingCategory);
        fundBody.innerHTML = rows
            .map(
                (fund) => `<tr data-fund="${fund.co}">
                    <td style="font-weight:600">${fund.co}</td><td class="mono" style="font-size:12px">${fund.round}</td>
                    <td class="amt">${fund.amt}</td>
                    <td><span class="catdot"><i style="background:${FCOLOR[fund.cat] || "#888"}"></i>${fund.cat}</span></td>
                    <td style="color:#9fb3b0">${fund.inv}</td>
                </tr>`
            )
            .join("");
        const fstat = $("#fstat");
        if (fstat) fstat.textContent = rows.length + " deals tracked";
        $$("#fundBody tr").forEach((tr) => tr.addEventListener("click", () => toast("Deal profile · " + tr.dataset.fund + " — full cap table in DHN+")));
    };

    const renderIntel = () => {
        $("#fundFilters")?.addEventListener("click", (event) => {
            const button = event.target.closest(".fchip");
            if (!button) return;
            fundingCategory = button.dataset.fc;
            renderFund();
        });
        renderFund();

        const radar = $("#radar");
        if (radar) {
            radar.innerHTML = POLICY.map((policy) => `<div class="pcard" data-policy="${policy.t}">
                <span class="status ${policy.cls}">${policy.s}</span><h4>${policy.t}</h4><p>${policy.d}</p><div class="date">${policy.date}</div>
            </div>`).join("");
            $$("#radar .pcard").forEach((card) => card.addEventListener("click", () => toast("Policy tracker · " + card.dataset.policy + " — timeline & compliance steps in DHN+")));
        }

        const bars = $("#bars");
        if (bars) {
            bars.innerHTML = INDEX.map((row) => `<div class="barrow"><span class="st">${row.st}</span>
                <div class="track"><div class="fill" data-v="${row.v}"></div></div><span class="score">${row.v}</span></div>`).join("");
        }

        $("#intelTabs")?.addEventListener("click", (event) => {
            const button = event.target.closest(".tab");
            if (!button) return;
            $$(".tab").forEach((tab) => tab.classList.remove("active"));
            button.classList.add("active");
            $$(".pane").forEach((pane) => pane.classList.remove("show"));
            $("#pane-" + button.dataset.pane)?.classList.add("show");
            if (button.dataset.pane === "index") window.setTimeout(fillBars, 60);
        });
    };

    const fillBars = () => {
        $$("#bars .fill").forEach((fill) => {
            fill.style.width = fill.dataset.v + "%";
        });
    };

    const renderSimpleSections = () => {
        const hubs = $("#hubs");
        if (hubs) {
            hubs.innerHTML = HUBS.map((hub) => `<div class="hub" data-topic="${hub.t}">
                <div class="ic">${hub.ic}</div><h4>${hub.t}</h4><div class="n">${hub.n}</div></div>`).join("");
            $$("#hubs .hub").forEach((hub) => hub.addEventListener("click", () => toast("Topic hub · " + hub.dataset.topic)));
        }

        const eco = $("#ecoGrid");
        if (eco) {
            eco.innerHTML = ECO.map((item) => `<div class="ecard" data-eco="${item.t}" style="background-image:${item.g}">
                <div class="ribbon"></div>
                ${item.logo ? `<img class="ecard__logo" src="${item.logo}" alt="${item.t} logo">` : ""}
                <div class="ecard__body"><div class="k">${item.k}</div><h3>${item.t}</h3><p>${item.p}</p></div></div>`).join("");
            $$("#ecoGrid .ecard").forEach((card) => card.addEventListener("click", () => toast("Ecosystem · " + card.dataset.eco)));
        }

        const reports = $("#reportGrid");
        if (reports) {
            reports.innerHTML = REPORTS.map((report) => {
                const reportImage = report.image
                    ? `<img class="cover-image" src="${report.image}" alt="${report.t}" loading="lazy" onerror="this.remove()">`
                    : "";
                return `<div class="report" data-report="${report.t}">
                    <div class="cover" style="background:${report.g}">${reportImage}<span class="lab">${report.lab}</span><h4>${report.t}</h4></div>
                    <div class="rb"><div class="meta">${report.meta}</div><div class="dl">Download →</div></div></div>`;
            }).join("");
            $$("#reportGrid .report").forEach((report) => report.addEventListener("click", () => toast("Report · " + report.dataset.report + " — preview in DHN+")));
        }

        const stats = $("#stats");
        if (stats) {
            stats.innerHTML = STATS.map((stat) => `<div class="stat"><div class="num"><span class="cnt" data-to="${stat[0]}">0</span>${stat[1]}</div><div class="lab">${stat[2]}</div></div>`).join("");
        }
    };

    const subs = new Set(["Daily Pulse"]);
    const renderNewsletters = () => {
        const nlGrid = $("#nlGrid");
        if (!nlGrid) return;
        nlGrid.innerHTML = NEWSLETTERS.map((newsletter) => {
            const on = subs.has(newsletter.t);
            return `<div class="nl"><h4>${newsletter.flag ? "★ " : ""}${newsletter.t}</h4><div class="freq">${newsletter.f}</div><p>${newsletter.d}</p>
                <button class="${on ? "on" : ""}" data-nl="${newsletter.t}">${on ? "✓ Subscribed" : "Subscribe"}</button></div>`;
        }).join("");
        $$("#nlGrid button").forEach((button) =>
            button.addEventListener("click", () => {
                const title = button.dataset.nl;
                subs.has(title) ? subs.delete(title) : subs.add(title);
                renderNewsletters();
            })
        );
    };

    const subscribeAll = () => {
        const email = $("#nlEmail")?.value.trim() || "";
        if (!email || !email.includes("@")) {
            toast("Enter a valid email");
            return;
        }
        if (!subs.size) {
            toast("Pick at least one franchise");
            return;
        }
        toast("✓ " + email + " subscribed to " + subs.size + " franchise" + (subs.size > 1 ? "s" : ""));
        $("#nlEmail").value = "";
    };

    let counted = false;
    const runCounters = () => {
        if (counted) return;
        counted = true;
        $$(".cnt").forEach((counter) => {
            const target = +counter.dataset.to;
            let current = 0;
            const step = Math.max(1, Math.ceil(target / 40));
            const timer = window.setInterval(() => {
                current += step;
                if (current >= target) {
                    current = target;
                    window.clearInterval(timer);
                }
                counter.textContent = current;
            }, 28);
        });
    };

    const initMorningSliders = () => {
        $$("[data-morning-slider]").forEach((morningSlider) => {
            const slides = [...morningSlider.querySelectorAll("[data-morning-slide]")];
            const dots = [...morningSlider.querySelectorAll("[data-morning-dot]")];
            const previous = morningSlider.querySelector("[data-morning-prev]");
            const next = morningSlider.querySelector("[data-morning-next]");
            if (!slides.length) return;

            const autoplayDelay = 6500;
            const transitionDuration = 850;
            const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            let activeSlide = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
            let autoplay;
            let transitionTimer;
            let pointerStartX = 0;
            let pointerStartY = 0;

            const showSlide = (index, direction = 1) => {
                const targetSlide = (index + slides.length) % slides.length;
                if (targetSlide === activeSlide || morningSlider.classList.contains("is-transitioning")) return;

                const outgoingSlide = slides[activeSlide];
                const incomingSlide = slides[targetSlide];

                window.clearTimeout(transitionTimer);
                morningSlider.classList.add("is-transitioning", direction < 0 ? "is-backward" : "is-forward");
                outgoingSlide.classList.add(direction < 0 ? "is-exiting-right" : "is-exiting-left");
                incomingSlide.classList.add(direction < 0 ? "is-entering-left" : "is-entering-right");
                incomingSlide.classList.add("is-active");
                incomingSlide.setAttribute("aria-hidden", "false");
                outgoingSlide.setAttribute("aria-hidden", "true");
                activeSlide = targetSlide;

                slides.forEach((slide, slideIndex) => {
                    slide.setAttribute("aria-hidden", slideIndex === activeSlide ? "false" : "true");
                });
                dots.forEach((dot, dotIndex) => {
                    const isActive = dotIndex === activeSlide;
                    dot.classList.toggle("is-active", isActive);
                    dot.setAttribute("aria-current", isActive ? "true" : "false");
                });

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => incomingSlide.classList.remove("is-entering-left", "is-entering-right"));
                });

                transitionTimer = window.setTimeout(() => {
                    outgoingSlide.classList.remove("is-active", "is-exiting-left", "is-exiting-right");
                    morningSlider.classList.remove("is-transitioning", "is-forward", "is-backward");
                }, transitionDuration);
            };

            const startAutoplay = () => {
                window.clearInterval(autoplay);
                if (prefersReducedMotion) {
                    morningSlider.classList.add("is-paused");
                    return;
                }
                morningSlider.classList.remove("is-paused");
                autoplay = window.setInterval(() => showSlide(activeSlide + 1, 1), autoplayDelay);
            };

            const stopAutoplay = () => {
                window.clearInterval(autoplay);
                morningSlider.classList.add("is-paused");
            };

            previous?.addEventListener("click", () => {
                showSlide(activeSlide - 1, -1);
                startAutoplay();
            });
            next?.addEventListener("click", () => {
                showSlide(activeSlide + 1, 1);
                startAutoplay();
            });
            dots.forEach((dot) => {
                dot.addEventListener("click", () => {
                    const targetSlide = Number(dot.dataset.morningDot);
                    showSlide(targetSlide, targetSlide < activeSlide ? -1 : 1);
                    startAutoplay();
                });
            });
            morningSlider.addEventListener("mouseenter", stopAutoplay);
            morningSlider.addEventListener("mouseleave", startAutoplay);
            morningSlider.addEventListener("focusin", stopAutoplay);
            morningSlider.addEventListener("focusout", startAutoplay);
            morningSlider.addEventListener("keydown", (event) => {
                if (event.key === "ArrowLeft") {
                    event.preventDefault();
                    showSlide(activeSlide - 1, -1);
                    startAutoplay();
                }
                if (event.key === "ArrowRight") {
                    event.preventDefault();
                    showSlide(activeSlide + 1, 1);
                    startAutoplay();
                }
            });
            morningSlider.addEventListener(
                "pointerdown",
                (event) => {
                    pointerStartX = event.clientX;
                    pointerStartY = event.clientY;
                },
                { passive: true }
            );
            morningSlider.addEventListener(
                "pointerup",
                (event) => {
                    const distanceX = event.clientX - pointerStartX;
                    const distanceY = event.clientY - pointerStartY;
                    if (Math.abs(distanceX) < 45 || Math.abs(distanceX) < Math.abs(distanceY)) return;
                    showSlide(activeSlide + (distanceX < 0 ? 1 : -1), distanceX < 0 ? 1 : -1);
                    startAutoplay();
                },
                { passive: true }
            );
            document.addEventListener("visibilitychange", () => {
                if (document.hidden) stopAutoplay();
                else startAutoplay();
            });
            startAutoplay();
        });
    };

    const initSearchAndTheme = () => {
        const searchOverlay = $("#searchOv");
        const searchInput = $("#searchInput");
        const closeSearch = (query) => {
            if (!searchOverlay) return;
            searchOverlay.classList.remove("is-showing");
            searchOverlay.setAttribute("aria-hidden", "true");
            if (query) toast(`Searching "${query}" across DHN...`);
        };

        $("#searchBtn")?.addEventListener("click", () => {
            if (!searchOverlay || !searchInput) return;
            searchOverlay.classList.add("is-showing");
            searchOverlay.setAttribute("aria-hidden", "false");
            window.setTimeout(() => searchInput.focus(), 50);
        });
        searchInput?.addEventListener("keydown", (event) => {
            if (event.key === "Enter") closeSearch(event.target.value);
        });
        $$("[data-search]").forEach((button) => button.addEventListener("click", () => closeSearch(button.dataset.search)));

        $("#themeBtn")?.addEventListener("click", () => {
            const isDark = document.documentElement.getAttribute("data-theme") === "dark";
            document.documentElement.setAttribute("data-theme", isDark ? "light" : "dark");
            const icon = $("#themeIcon");
            if (!icon) return;
            icon.innerHTML = isDark
                ? '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/>'
                : '<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>';
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeSearch();
                closeOverlay();
            }
        });
    };

    const initGlobalInteractions = () => {
        $$("[data-scroll-target]").forEach((button) => {
            button.addEventListener("click", () => {
                const target = document.getElementById(button.dataset.scrollTarget);
                if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
            });
        });
        $$("[data-jump]").forEach((link) =>
            link.addEventListener("click", () => {
                const cat = link.dataset.jump;
                $$("#filters .chip").forEach((chip) => chip.classList.toggle("active", chip.dataset.cat === cat));
                renderFeed(cat);
            })
        );
        $("#overlay")?.addEventListener("click", (event) => {
            if (event.target.id === "overlay" || event.target.closest("[data-close-overlay]")) closeOverlay();
        });
        $("#subscribeAllBtn")?.addEventListener("click", subscribeAll);
    };

    const initReveal = () => {
        const revealEls = $$(".reveal");
        if (!("IntersectionObserver" in window)) {
            revealEls.forEach((el) => el.classList.add("in"));
            fillBars();
            runCounters();
            return;
        }
        const observer = new IntersectionObserver(
            (entries) =>
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;
                    entry.target.classList.add("in");
                    if (entry.target.id === "plus") runCounters();
                    if (entry.target.id === "intel" && $("#pane-index")?.classList.contains("show")) fillBars();
                    observer.unobserve(entry.target);
                }),
            { threshold: 0.12 }
        );
        revealEls.forEach((el) => observer.observe(el));
    };

    const scrollToCurrentHash = () => {
        const hash = window.location.hash.replace("#", "");
        if (!hash) return;

        const target = document.getElementById(decodeURIComponent(hash));
        if (!target) return;

        const revealTarget = target.classList.contains("reveal") ? target : target.closest(".reveal");
        if (revealTarget) {
            revealTarget.classList.add("in");
            if (revealTarget.id === "plus") runCounters();
            if (revealTarget.id === "intel" && $("#pane-index")?.classList.contains("show")) fillBars();
        }

        const scrollTargetIntoView = () => target.scrollIntoView({ block: "start" });
        window.setTimeout(scrollTargetIntoView, 80);
        window.setTimeout(scrollTargetIntoView, 350);
    };

    setDate();
    renderTicker();
    renderFilters();
    renderFeed("All");
    renderIntel();
    renderSimpleSections();
    renderNewsletters();
    bindArticles();
    initMorningSliders();
    initSearchAndTheme();
    initGlobalInteractions();
    initReveal();
    scrollToCurrentHash();
    window.addEventListener("hashchange", scrollToCurrentHash);
})();
